import { render, staticRenderFns } from "./createTeam.vue?vue&type=template&id=51f5fd06&"
import script from "./createTeam.vue?vue&type=script&lang=js&"
export * from "./createTeam.vue?vue&type=script&lang=js&"
import style0 from "./createTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports